import React, { useEffect, useState } from "react";
import { useTable, useSortBy, usePagination } from "react-table";
import { PrevBtn, NextBtn, PaginationWrapper } from "../Styles/PageStyles";
import Images from "../../Images";
import tw from "tailwind-styled-components";
import moment from "moment";
import  { PaginationLimit } from "../../Config";
import { useNavigate } from "react-router-dom";
import { IoCopySharp } from "react-icons/io5";
import { capitalizeFirstLetter, handleCopy, truncateText } from "../../helpers";
import { MdOutlineChevronRight } from "react-icons/md";
import { FaCheck } from "react-icons/fa";

const RenewedAgreementTable = ({
  apiData,
  setSelectedData,
  setIsViewAgreement,
}) => {
  const storageKey = `tenant_valid_agreement_page`;
  const [data, setData] = useState([]);
  const navigate = useNavigate();
  const [selectedRow, setSelectedRow] = useState(null);
  const [isMobileView, setIsMobileView] = useState(window.innerWidth < 768);
  const [openActionMenu, setOpenActionMenu] = useState(null);
  const storageValue = sessionStorage.getItem(storageKey);
  const savedPage = storageValue !== null ? Number(storageValue) : 0;
  const [currentPage, setCurrentPage] = useState(savedPage);
  const toggleRow = (index) => {
    setSelectedRow(selectedRow === index ? null : index);
  };
  useEffect(() => {
    setCurrentPage(savedPage);
  }, [savedPage]);

  const viewAgreement = (item) => {
    setIsViewAgreement(true);
    setSelectedData(item);
    setOpenActionMenu(null);
  };
  const goToTenantDetails = (item) => {
    navigate(`/tenant/${item.tenantId}`, {
      state: {
        tabName: "Tenant Info",
        tabKey: "totalDues",
      },
    });
  };

  useEffect(() => {
    if (apiData) {
      const tempData = apiData.map((item) => ({
        name: getName(item),
        property: getProperty(item),
        agreement: getAgreementInfo(item),
        rent: <Amount>{"₹" + item.rent}</Amount>,
        security: getSecurityInfo(item),
        action: ActionBtns(item),
        renewedOn: moment(item?.createdAt).format("DD, MMM YY"),
      }));
      setData(tempData);
    }
  }, [apiData, openActionMenu]);
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        !event.target.closest("#menuOptions") &&
        !event.target.closest(".action-btn")
      ) {
        setOpenActionMenu(null);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const getName = (item) => {
    const name = capitalizeFirstLetter(item?.tenantName || "");
    return (
      <UserImageWrapper onClick={() => goToTenantDetails(item)}>
        <div className="flex-row flex">
          <UserImage
            src={item.profilePicture ? item.profilePicture : Images.Avatar}
            alt={`Avatar for ${item.tenantName}`}
          />
          {(item.kycStatus === 5 || item.kycStatus === 4) && (
            <div className="mt-auto rounded-full bg-green-500 h-4 w-4 flex items-center justify-center -ml-2.5">
              <FaCheck className="text-white" size={10} />
            </div>
          )}
        </div>
        <div className="flex flex-col gap-1">
          <span className="text-gray-600 text-sm font-medium">
            {truncateText(name, 25)}
          </span>
          <div className="flex gap-1">
            <span className="text-gray-400 text-xs">#{item.tenantMobile}</span>
            <button
              onClick={(e) => {
                e.stopPropagation();
                handleCopy(item.tenantMobile);
              }}
            >
              <IoCopySharp size={10} className="text-gray-400" />
            </button>
          </div>
        </div>
      </UserImageWrapper>
    );
  };

  const getProperty = (item) => {
    return (
      <span className="text-gray-600 text-sm">
        {truncateText(` ${item.inventoryName}`, 25)}
      </span>
    );
  };

  const getAgreementInfo = (item) => {
    const startDate = item.agreementStartDate
      ? moment(item.agreementStartDate).format("DD, MMM YY")
      : "-";

    const endDate =
      item.agreementStartDate && item.agreementPeriod
        ? moment(item.agreementStartDate)
            .add(item.agreementPeriod, "months")
            .format("DD, MMM YY")
        : "-";

    return (
      <div className="flex flex-col gap-1">
        <div className="flex items-center gap-2">
          <div className="flex flex-col">
            <span className="text-gray-600 text-sm">
              {startDate} to {endDate}
            </span>
            {item.doneByName && (
              <span className="text-gray-400 text-xs">
                {truncateText("Done by " + item.doneByName, 30)}
              </span>
            )}
          </div>
        </div>
      </div>
    );
  };

  const getSecurityInfo = (item) => {
    return (
      <div className="flex flex-col gap-1">
        <div className="flex items-center gap-2">
          <span className="text-gray-600 text-sm font-medium">
            ₹{item.security || 0}
          </span>
        </div>
        {/* {item.prevSecurity && ( */}
        <div className="flex items-center gap-2">
          <span className="text-gray-400 text-xs">
            Prev: ₹{item.prevSecurity || 0}
          </span>
        </div>
        {/* )} */}
      </div>
    );
  };

  const ActionBtns = (item) => {
    return (
      <div className="flex gap-4">
        <button
          onClick={() => viewAgreement(item)}
          className={`cursor-pointer text-sm px-4 py-1 rounded-lg ${" text-gray-600"} flex items-center gap-1`}
        >
          {/* Edit */}
          <MdOutlineChevronRight className="text-gray-300" size={24} />
        </button>
      </div>
    );
  };

  useEffect(() => {
    const handleResize = () => {
      setIsMobileView(window.innerWidth < 768);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const columns = React.useMemo(() => {
    if (isMobileView) {
      return [
        {
          Header: "Tenant",
          accessor: "name",
          width: 150,
        },
        {
          Header: "Agreement",
          accessor: "agreement",
          width: 120,
        },
      ];
    }

    return [
      {
        Header: "Name",
        accessor: "name",
        // width: 150,
      },
      {
        Header: "Inventory",
        accessor: "property",
        // width: 150,
      },
      {
        Header: "Rent",
        accessor: "rent",
        // width: 100,
      },
      {
        Header: "AGMT Duration",
        accessor: "agreement",
        // width: 200,
      },
      {
        Header: "Renewed On",
        accessor: "renewedOn",
        // width: 100,
      },
      {
        Header: "",
        accessor: "action",
        width: 80,
      },
    ];
  }, [isMobileView]);

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,
    pageOptions,
    page,
    state: { pageIndex, pageSize },
    previousPage,
    nextPage,
    setPageSize,
    canPreviousPage,
    canNextPage,
  } = useTable(
    {
      data,
      columns,
      initialState: { pageIndex: currentPage, pageSize: PaginationLimit },
    },
    useSortBy,
    usePagination,
  );

  useEffect(() => {
    sessionStorage.setItem(storageKey, pageIndex);
  }, [pageIndex, storageKey]);

  return (
    <>
      <CustomTable {...getTableProps()}>
        <Thead>
          {headerGroups.map((headerGroup) => (
            <Tr {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.map((column) => (
                <Th
                  {...column.getHeaderProps(column.getSortByToggleProps())}
                  // style={{ width: column.width }}
                >
                  {/* <div className="flex items-center"> */}
                  {column.render("Header")}
                  <span>
                    {column.isSorted ? (
                      <img
                        src={Images.Arrow}
                        alt="sort arrow"
                        className={`${
                          column.isSortedDesc ? "-rotate-90" : "rotate-90"
                        } w-1.5 inline-block ml-1.5`}
                      />
                    ) : (
                      ""
                    )}
                  </span>
                  {/* </div> */}
                </Th>
              ))}
            </Tr>
          ))}
        </Thead>
        <Tbody
          {...getTableBodyProps()}
          hasdata={(apiData?.length > 0).toString()}
        >
          {page.map((row, rowIndex) => {
            prepareRow(row);
            return (
              <React.Fragment key={rowIndex}>
                <Tr
                  {...row.getRowProps({ style: { height: "80px" } })}
                  hasdata={(apiData?.length > 0).toString()}
                >
                  {row.cells.map((cell, cellIndex) => {
                    return (
                      <Td
                        {...cell.getCellProps()}
                        onClick={() => {
                          if (
                            cellIndex === 0 ||
                            (cellIndex === 1 && isMobileView)
                          ) {
                            toggleRow(rowIndex);
                          }
                        }}
                        style={{ maxWidth: "320px" }}
                      >
                        {cell.render("Cell")}
                      </Td>
                    );
                  })}
                </Tr>

                {/* Mobile expanded view */}
                {isMobileView && selectedRow === rowIndex && (
                  <Tr className="bg-gray-50">
                    <Td colSpan={columns.length}>
                      <ul className="flex flex-col gap-2">
                        <li className="flex gap-2">
                          <strong>Inventory:</strong> {data[rowIndex].property}
                        </li>
                        <li className="flex gap-2">
                          <strong>Rent:</strong> {data[rowIndex].rent}
                        </li>
                        <li>
                          <strong>Security:</strong> {data[rowIndex].security}
                        </li>
                      </ul>
                    </Td>
                  </Tr>
                )}
              </React.Fragment>
            );
          })}
        </Tbody>
      </CustomTable>

      {data.length > 0 && (
        <PaginationWrapper>
          <div className="px-2">
            Page{" "}
            <em>
              {pageIndex + 1} of {pageOptions.length}
            </em>
          </div>

          <div className="flex gap-1">
            <PrevBtn onClick={() => previousPage()} disabled={!canPreviousPage}>
              <img src={Images.Arrow} alt="arrow" className="w-2 opacity-75" />
            </PrevBtn>
            <NextBtn onClick={() => nextPage()} disabled={!canNextPage}>
              <img
                src={Images.Arrow}
                alt="arrow"
                className="w-2 rotate-180 opacity-75"
              />
            </NextBtn>
          </div>
        </PaginationWrapper>
      )}

      {/* {data.length === 0 && !isMobileView && (
                <div className="text-center py-8 text-gray-500">
                    No valid agreements found
                </div>
            )} */}
    </>
  );
};

// Styled Components
const CustomTable = tw.table` w-full text-zinc-600`;
const Thead = tw.thead`border-b uppercase text-gray-600 bg-blue-50`;
const Tbody = tw.tbody`${(props) => (props.hasdata === "true" ? "border-b" : "")}`;
const Tr = tw.tr`${(props) =>
  props.hasdata === "true"
    ? "border-b"
    : ""} rounded-md overflow-hidden hover:bg-slate-50`;
const Th = tw.th`text-left text-sm md:p-3 p-0.5 font-normal text-gray-600`;
const Td = tw.td`p-3 text-sm md:p-3 text-left`;
const UserImageWrapper = tw.div` flex items-center gap-2 cursor-pointer`;
const UserImage = tw.img`w-10 h-10 rounded-full `;
const Amount = tw.p`text-gray-600 text-sm bg-neutral-100 px-3 py-1 rounded-md inline-flex`;

export default RenewedAgreementTable;
